export enum ProfilePageParam {
  MAIN = 'all',
  MUSIC = 'music',
  MERCH = 'merch',
  TOUR = 'tour',
}
